import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Grid from '@material-ui/core/Grid';
import Button from 'components/Button/Button';

import { useFormatMessage } from 'components/IntlProvider';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      minWidth: '300px',
      outline: 'none',
      borderRadius: '4px',
    },
    confirmBtn: {
      marginRight: theme.spacing(2),
      backgroundColor: '#b00020',
      color: 'white',
      '&:hover': {
        backgroundColor: '#b00020b0',
      },
    },
    container: {
      marginBottom: theme.spacing(2),
    },
  })
);

interface RemoveModalProp {
  renderer: any;
  onConfirm: () => void;
  children: JSX.Element | React.ReactNode;
  isPositive?: boolean;
}

const RemoveModal = ({
  renderer,
  onConfirm,
  children,
  isPositive,
}: RemoveModalProp) => {
  const t = useFormatMessage();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(false);
  };

  const handleOnConfirm = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(false);
    onConfirm();
  };

  return (
    <>
      {renderer({
        handleOpen,
      })}
      <Modal
        aria-labelledby="transition-modal"
        aria-describedby="transition-modal"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        disablePortal
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Grid
              container
              justify="space-between"
              className={classes.container}
            >
              <span
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                {children}
              </span>
            </Grid>
            <Grid container justify="space-between">
              <Grid item>
                <Button
                  variant="contained"
                  onClick={handleOnConfirm}
                  className={classes.confirmBtn}
                  style={{
                    backgroundColor: isPositive ? '#0055ab' : '#b00020',
                  }}
                >
                  {t('pages.project.modal.confirm', 'Confirm')}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleClose}
                  style={{
                    backgroundColor: isPositive ? '#b00020' : '#0055ab',
                  }}
                >
                  {t('pages.project.modal.cancel', 'Cancel')}
                </Button>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default RemoveModal;
